import { useEffect } from "react";
import { useLocation, Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyContactBar } from "@/components/StickyContactBar";

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return (
    <div data-testid="app-shell" className="min-h-screen bg-[#f7fafb]">
      <Navbar />
      <main className="pb-20 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <StickyContactBar />
    </div>
  );
}
